import type { LocalDatabase } from '../core/types';
import type { RecordedSessionRecord } from '~/powersync/generated/schema';
import type { QueryBuilderSpec } from '~/powersync/types';

export const RecordedSessionQueries = {
  /** The session(s) attached to a workout, most-recently-ended first. */
  findByWorkout: (
    workoutId: string,
  ): QueryBuilderSpec<RecordedSessionRecord> => ({
    createQuery: (db: LocalDatabase) =>
      db
        .selectFrom('RecordedSession')
        .selectAll()
        .where('workoutId', '=', workoutId)
        .where('deletedAt', 'is', null)
        .orderBy('endedAt', 'desc'),
    queryKey: ['recordedSession', 'workoutId', workoutId],
  }),

  /** Sessions attached to any of the given workouts (for weekly aggregates). */
  findByWorkoutIds: (
    workoutIds: string[],
  ): QueryBuilderSpec<RecordedSessionRecord> => ({
    createQuery: workoutIds.length
      ? (db: LocalDatabase) =>
          db
            .selectFrom('RecordedSession')
            .selectAll()
            .where('workoutId', 'in', workoutIds)
            .where('deletedAt', 'is', null)
      : null,
    queryKey: ['recordedSession', 'workoutIds', ...workoutIds],
  }),
};
